export const SUPPORTED_HTML_TAGS = new Set([
  'a',
  'b',
  'blockquote',
  'br',
  'code',
  'div',
  'em',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hr',
  'i',
  'img',
  'li',
  'ol',
  'p',
  'pre',
  'span',
  'strong',
  'table',
  'tbody',
  'td',
  'th',
  'thead',
  'tr',
  'ul',
])

export function escapeHtmlAttribute(value: string) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

function getHtmlTagName(tag: string) {
  return tag.match(/^<\/?\s*([a-z][a-z0-9-]*)/i)?.[1]?.toLowerCase() || ''
}

export function shouldImportAsHtml(value: string) {
  return Array.from(value.matchAll(/<\/?\s*([a-z][a-z0-9-]*)\b[^>]*>/gi))
    .some((match) => {
      const tagName = String(match[1] || '').toLowerCase()
      return tagName !== 'img' && SUPPORTED_HTML_TAGS.has(tagName)
    })
}

export function escapeUnsupportedHtmlTags(value: string) {
  return value.replace(/<\/?\s*[a-z][a-z0-9-]*\b[^>]*>/gi, (tag) => {
    const tagName = getHtmlTagName(tag)
    return SUPPORTED_HTML_TAGS.has(tagName) ? tag : escapeHtmlAttribute(tag)
  })
}
